module.exports = __webpack_public_path__ + "static/img/Pastille-PB2025.710ee45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Pastille-PB2025.png
// module id = 748
// module chunks = 1